<template>
	<div v-loading="element_loading" element-loading-text="拼命加载中......" element-loading-spinner="el-icon-loading"
		element-loading-background="rgba(0, 0, 0, 0.8)">

		<div class="title">
			<div id="notice">
				<h5>费用核对&nbsp;&nbsp;说明:</h5><br>
				<span
					class="red">1、单号类型:YS=运输单、YF=运费申请单、PS=个人报销单、JK=个人借款单、SJ=司机费用报销、ZB=增补费、JW=就位费、BX=保险费、KL=看路费。</span><br>
				<span>2、双击显示明细信息,确定是否通过。</span><br>
				<span class="red">3、默认查询未打款或未确认数据。</span><br>
				<span class="red">4、已付状态可以用来补单。</span><br>
				<span>5、查询关键字:单号、打款状态、收款人、厂家、打款日期、打款金额</span><br>
				<!-- <span>查询:标题</span><br> -->
			</div>
		</div>
		<div class="content_edit">
			<pre-button @button-event="select_method" :pre_control="control" />
			<div class="content_btn">
				<div class="content_btn_item">
					<button @click="look_note">备注说明</button>
					<button @click="look_hetong">合同追加</button>
					<!-- <button @click="edit_mode">引入模板</button> -->
					<button class="pre_btn_ok" v-show="show_step_btn" @click="fun_show_step">审核流程</button>
				</div>
			</div>
		</div>

		<!-- 动态查询区生成 -->
		<div class="content_edit">
			<div class="content_edit_item" v-for="(item,index) in parm_sel" :key="index">
				<!-- {{handleImportView(item)}} -->
				<component :is="NextTickName(item.type)" :inData="checkJson(item)" @com-event="refresh_view_sel">
				</component>

			</div>
			<!-- <div class="content_edit_item" v-show="file_show">
				<label>文件:</label><span>{{file_name}}&nbsp;&nbsp;{{file_up}}</span>
			</div> -->
		</div>

		<pre-table ref="file_table" @tab-event="refresh_data" :api_url="load_url" :pre_post="load_json"
			:pre_post_upd="upd_json">
			<!-- 设定标题  -->
			<template slot="tab_title">
				<tr :class="[isTwo=='1'?TwoNone:'']">
					<th v-for="(t,index) in parm_th" :key="index">{{t.name}}</th>
					<th class="short0 cen">编辑</th>
				</tr>
			</template>
			<template slot="tab_tr" slot-scope="user">
				<tr v-bind:id="'m_' + user.item[1].val" :class="[isTwo=='1'?TwoNone:'']"
					@click="sel_row(user.item,'edit')" @dblclick="sel_row(user.item,'show')">
					<td v-for="(d,index) in user.item" :key="index" v-on:mousemove="show_detaildata($event, d.val, '1')"
						v-on:mouseout="noshow_detaildata">
						<div v-if="d.key=='img_url'">
							<el-image style="width: 20px; height: 20px" :src="check_url(d.val)"
								:preview-src-list="[check_url(d.val)]">
							</el-image>
						</div>
						<div v-else-if="d.key=='f_web_url'">
							<a :href="d.val" target="_blank">外链</a>
						</div>
						<div v-else>{{d.val}}</div>
					</td>
					<td class="short0 cen">
						<button @click="sel_row(user.item,'show')">编辑</button>
						<button @click="fun_del(user.item,'del')">删除</button>
					</td>
				</tr>
			</template>
			<!-- 构建新增模板 -->
			<template slot="tab_addorupdate">
			</template>
		</pre-table>

		<!-- 弹出向导层 start-->
		<pretan ref="mypop">
			<template slot="tancontent">
				<div style="width: 72vw;">
					<!-- 操作按钮生成 -->
					<div class="tab-row tab-menu">
						<div class="left">
							<h3 class="cen pretop">{{title}}</h3>
							&nbsp;&nbsp;&nbsp;&nbsp;
							<h5>合计金额=审核支出-审核已付-审核收入</h5>
						</div>
					</div>
					<div class="tab-row tab-menu">
						<div class="left">
							<pre-btn-pass @button-event="select_method" :pre_control="control" />
							<h3 v-show="sheet_flag!=''?true:false" class="red">
								{{sheet_flag}}
							</h3>
						</div>
					</div>

					<div class="tab-main">

						<div class="content_edit_item tab-row" v-for="(r,d) in max_row" :key="d">
							<div class="content_edit_item" v-if="item.x == r.row" v-for="(item,index) in parm"
								:key="index">
								<!-- {{handleImportView(item)}} -->

								<component ref="editfatherzj" :is="NextTickName(item.type)" :inData="checkJson(item)"
									@com-event="refresh_view_edit">
								</component>
							</div>
						</div>

						<!-- <div class=" content_edit_item tab-row" v-if="list_main.amount_all>0">
							<div class="item">
								<label>总运费:</label><span>{{list_main.amount_all}}</span>
							</div>
							<div class="item">
								<label>已付现金:</label><span>{{list_main.amount_xj}}</span>
							</div>
							<div class="item">
								<label>已付油:</label><span>{{list_main.amount_y}}</span>
							</div>
							<div class="item">
								<label>未付现金:</label><span>{{list_main.amount_no_xj}}</span>
							</div>
							<div class="item">
								<label>未付油:</label><span>{{list_main.amount_no_y}}</span>
							</div>
						</div> -->

						<div class="content_edit_item tab-row" v-show="file_show">
							<label>文件:</label><span>{{file_name}}&nbsp;&nbsp;{{file_up}}</span>
						</div>

					</div>

					<div class="tab-detail">
						<h5 class="cen pretop">费用明细</h5>
					</div>


					<!-- 这里放明细单据内容 -->
					<!-- 明细部分编辑区 -->
					<table class="dataintable" border="1" cellpadding="2" cellspacing="1">
						<tr class="tab_header_new">
							<td>序号</td>
							<td>业务单号</td>
							<td>费用名称</td>
							<td>申请金额</td>
							<td>申请备注</td>
							<td>收入|支出</td>
							<td>支付日期</td>
							<td>油卡卡号</td>
							<td>开票</td>
							<td>公司已支付</td>
							<td>附件</td>
							<td>确认金额</td>
							<td>确认备注</td>
							<td class="short0 cen">操作</td>
						</tr>
						<tr :id="'d_'+data_tr.row_num" v-for="data_tr in list_detail">
							<!-- <td>{{data_tr.id}}</td> -->
							<td>{{data_tr.row_num}}</td>
							<td>{{data_tr.sheet_no}}</td>
							<td>{{data_tr.apply_name}}</td>
							<td>{{data_tr.apply_amount}}</td>
							<td v-on:mousemove="show_detaildata($event, data_tr.apply_note, '1')"
								v-on:mouseout="noshow_detaildata">{{data_tr.apply_note}}</td>
							<td>{{data_tr.amount_flag}}</td>
							<td>{{data_tr.apply_date}}</td>
							<td>{{data_tr.f_no}}</td>
							<td>{{data_tr.is_paper}}</td>
							<td>{{data_tr.is_pay}}</td>
							<td>
								<el-image style="width: 20px; height: 20px" :src="check_url(data_tr.img_url)"
									:preview-src-list="[check_url(data_tr.img_url)]">
									<div slot="error" class="image-slot">
										<i class="el-icon-picture-outline"></i>
									</div>
								</el-image>
							</td>
							<td>
								<input style="width: 108px;" type="number" v-model="data_tr.ok_amount"
									@keyup.enter="fun_d_upd('_upd',data_tr)" />
							</td>
							<td>
								<input style="width: 168px;" type="text" v-model="data_tr.ok_note"
									@keyup.enter="fun_d_upd('_upd',data_tr)" />
							</td>
							<td class="short0 cen">
								<button @click="fun_d_del('_del',data_tr)">删除</button>
							</td>
						</tr>
					</table>
				</div>
			</template>
		</pretan>

		<!-- 弹出向导层 end-->

		<pre-step :pre_show_tan="show_step" :pre_data="show_stepdata" />

		<!-- 文件预览部分 -->
		<!-- 预览 与 下载 start-->
		<!-- <input class="displayno" type="file" id="savefile" v-on:change="getFilePath" multiple="multiple" /> -->
		<input class="displayno" type="file" id="savefile" v-on:change="getFilePath" />

		<a id="downlink"></a>
		<a id="loodlink" target="_blank"></a>

		<!-- 通用导出excel -->
		<per-exceldown v-show="show_excel" @exceldown-event="build_exceldata" :title="'下载数据'"
			v-bind:pre_postjson="postjson1" :clicktype="'down1'">
			<template slot="tab_excelup_title">
				<tr>
					<th>ID</th>
					<th v-for="(t,index) in parm_th" :key="index">{{t.name}}</th>
				</tr>
			</template>
			<template slot="tab_excelup_tr" slot-scope="user">
				<tr>
					<td v-for="(d,index) in user.item" :key="index">{{d.val}}</td>
				</tr>
			</template>
		</per-exceldown>

		<!-- 文件列表 -->
		<pre-file-type ref="filetype" />

		<!-- 明细数据提示 -->
		<div id="pre_detail_data" style="display:none;">
			<p v-for="(item, index) in detail_data" :key="index">
				{{ item.name }}={{ item.amount }}
			</p>
		</div>
		<div id="pre_msg_data" style="display:none;"></div>


	</div>
</template>

<script>
	/*


*/
	import api from '@/utils/type.js';
	import {
		Select_PageLength,
		Method_Common,
		Method_EasySelect,
		Sel_page_and_length
	} from '@/utils/loadhttpdata.js';

	import {
		ReplaceAll
	} from '@/utils/method.js';

	// 文件操作辅助方法
	import {
		base_encode
	} from "@/utils/base64.js";
	import {
		GetShort,
		DeleteSpecialWord,
		BackSpecial,
		ChangeSpecial,
		GetRandom
	} from "@/utils/localstore.js";
	import {
		BrowserGet
	} from '@/utils/systemSelect.js';
	import {
		number
	} from 'echarts';


	export default {
		components: {
			"pre-button": () => import("../per_mode/pre_btn_control.vue"),
			"pre-btn-pass": () => import("../per_mode/pre_btn_pass_tan.vue"),
			"pre-table": () => import("../auto/old_view_table.vue"),
			'per-exceldown': () => import("../per_old/pre_excel_down.vue"),
			'per-excelup': () => import("../per_old/pre_excel_up_new.vue"),
			'pre-file-type': () => import("../base_comp/tan_file_type.vue"),
			"pre-step": () => import("../per_old/pre_base_tan_step.vue")
		},
		data() {
			return {
				element_loading: false,
				detail_data: [],

				max_row: 10,
				control: '',
				load_url: '',
				load_json: '',
				upd_json: '',
				nowpage: '1',
				page_length: 20, //add 2022-01-25 默认分页长度
				title: '未设置标题',
				sel_action: '',
				upd_action: '',
				edit_flag: '', //add 2022-02-15 编辑类型标识
				check_key: '', //add 2022-02-15 结构匹配标识
				row_id: '',
				sys_date: '',
				list_upfileall: [],

				pop_show: false,
				screenWidth: '',
				screenHeight: '',

				// 审核标记
				sheet_flag: '',
				sheet_no: '',
				show_btn: true,

				parm_sel: [], //查询结构
				parm: [], //参数结构
				parm_th: [], //标题
				kw1: '',
				kw2: '',
				kw3: '',
				kw4: '',
				kw5: '',
				kw6: '',
				kw7: '',
				kw8: '',
				kw9: '',

				show_detail: false,
				d_sel_action: '',
				d_upd_action: '',
				d_row_id: '',
				d_sys_date: '',
				d_parm: [], //明细参数构造
				d_name: [], //明细标题
				d_detail: [], //明细数据

				f_name: "",

				//文件
				file_show: false,
				file_name: "",
				file_data: "",
				file_up: "",
				file_url: "",
				file_src: "",
				file_size: "",
				file_type: '',
				file_action: '',
				blockSize: '',
				file_backdata: '',
				p1: '',
				p2: '',
				p3: '',


				list_dep: [],
				list_user: [],

				// 定义默认样式
				isTwo: '1',
				isTwoDetail: '0',
				TwoNone: 'last-two-none',

				list_main: {},
				list_detail: [],

				pre_list_data: [{
					"id": "0",
					"val": "待打款"
				}, {
					"id": "1",
					"val": "已打款"
				}],


				sel_radio: '0',
				pay_date: '',
				pay_note: '',

				// 自定义组件 流程
				show_step: '0',
				show_stepdata: '',
				pass_step: "0",
				show_step_btn: false,


				out_amount: 0,
				out_ok: 0,

				// excel
				show_excel: false,
				postjson1: {},



			};
		},
		activated() {
			console.log('激活');
		},
		mounted() {
			// console.log('加载');
			this.load_data();
		},
		methods: {
			fun_show_step: function() {
				console.log('sheet_no=' + this.sheet_no);
				if (typeof(this.sheet_no) == "undefined" || this.sheet_no == '') {
					this.$message({
						message: '请选择要操作的单据信息!',
						type: 'warning'
					});
					return
				}

				this.show_stepdata = '';
				this.show_stepdata = JSON.stringify({
					"title": this.title + '流程',
					"sheet_no": this.sheet_no,
					"sel_action": 'exp_step'
				});
				this.show_step = (Math.random() + '').substring(0, 8);

			},
			fun_option: function(e) {
				console.log('radio=' + e);
				this.sel_index = e;
			},
			look_hetong: function() {
				if (this.row_id == 0) {
					this.$message({
						message: '请选择要添加 合同与票据 的调度单!',
						type: 'warning'
					});
					return;
				}

				let post_tan = JSON.stringify({
					"title": "合同与票据",
					"sheet_flag": this.sheet_flag,
					"sheet_no": this.sheet_no,
					"sel_action": "exp_filemode_com",
					"file_action": "filemode_com",
				})
				this.$refs.filetype.showpop(post_tan);
			},
			NextTickName: function(key) {
				// console.log('key=' + key);
				return 'pre' + key;
			},
			checkJson: function(d) {
				let temp = '';
				temp = JSON.stringify(d)
				return temp;
			},
			refresh_view_sel: async function(d) {
				// console.log('查询回传=', d);
				for (let i = 0; i < this.parm_sel.length; i++) {
					if (this.parm_sel[i].key == d.key) {
						this.parm_sel[i].val = d.val;

						if (d.key == 'd_name') {
							for (let j = 0; j < this.parm_sel.length; j++) {
								if (this.parm_sel[j].key == 'u_name') {
									let res = await this.loadClass('_base_user_by_d', d.val);
									// console.log(res.data);
									this.parm_sel[j].list = [];
									this.parm_sel[j].list = res.data;
								}
							}
						}

						break;
					}
				}
				// console.log('更新后', this.parm_sel)


			},
			refresh_view_edit: async function(d, type) {
				// console.log(d);
				for (let i = 0; i < this.parm.length; i++) {
					if (this.parm[i].key == d.key) {
						if (this.parm[i].type == 'select' || this.parm[i].type == 'radio') {
							this.parm[i].val = d.val;
							this.parm[i].sel_name = d.sel_name;

							if (d.key == 'd_name') {
								for (let j = 0; j < this.parm.length; j++) {
									if (this.parm[j].key == 'u_name') {
										let res = await this.loadClass('_base_user_by_d', d.val);
										this.parm[j].list = [];
										this.parm[j].list = res.data;
									}
								}
							}

							break;
						} else {
							this.parm[i].val = d.val;
							break;
						}
					}
				}

				if (type == 'save') {
					this.fun_upd('_add');
				}
			},
			refresh_view_edit_d: function(d, type) {
				for (let i = 0; i < this.d_parm.length; i++) {
					if (this.d_parm[i].key == d.key) {
						if (this.d_parm[i].type == 'select' || this.d_parm[i].type == 'radio') {
							this.d_parm[i].val = d.val;
							this.d_parm[i].sel_name = d.sel_name;
							break;
						} else {
							this.d_parm[i].val = d.val;
							break;
						}
						break;
					}
				}
				if (type == 'save') {
					this.fun_upd('_add');
				}
			},
			check_is_pdf: function(res_url) {
				let is_pdf = false;
				if (/\.(pdf)$/.test(res_url.toLowerCase())) {
					is_pdf = true;
				}
				return is_pdf;
			},
			check_url: function(url) {
				let t = BackSpecial(url);
				// console.log(t);
				return t;
			},
			look_note: function() {
				//收缩区 收放设置
				this.show_note = this.show_note ? false : true;
				if (this.show_note) {
					$("#notice").slideDown("slow");
				} else {
					$("#notice").slideUp("slow");
				}
			},
			load_data: async function() {
				// console.log(r);
				// 清理缓存
				this.max_row = [];
				for (let i = 1; i < 6; i++) {
					let o = {};
					o.row = i;
					this.max_row.push(o);
				}

				this.control = 'cwcheck';
				this.sel_action = 'exp_cw_fee_check_m';
				this.api_url = api.http_method;
				this.upd_action = '_cw_fee_check_m';
				this.title = '财务费用核对';
				this.isTwo = '1';
				// this.step = '1';
				this.show_step_btn = true; //判断是否有业务流程

				this.parm_sel = [{
						"name": "单号",
						"val": "",
						"key": "sheet_no",
						"type": "text",
						"class": "long1",
						"sel": "1"
					},
					{
						"name": "状态",
						"val": "",
						"key": "flag",
						"type": "select",
						"class": "long1",
						"sel_action": "data_flag",
						"sel_name": "",
						"sel": "2"
					},
					{
						"name": "收款人",
						"val": "",
						"key": "u2_name",
						"type": "text",
						"class": "long1",
						"sel": "3"
					},
					{
						"name": "厂家",
						"val": "",
						"key": "c_name",
						"type": "text",
						"class": "long1",
						"sel": "4",
					},
					{
						"name": "更新日期",
						"val": "",
						"key": "sys_date",
						"type": "date",
						"class": "long1",
						"sel": "5",
					},
				]

				this.parm = [{
						"name": "业务单号",
						"val": "",
						"key": "sheet_no",
						"type": "label",
						"class": "black",
						"p": "1",
						"w": "0",
						"r": "0",
						"x": "1"
					},
					{
						"name": "申请人",
						"val": "",
						"key": "user_name",
						"type": "label",
						"class": "black",
						"p": "0",
						"w": "0",
						"r": "0",
						"x": "1"
					},
					{
						"name": "收款人",
						"val": "",
						"key": "rec_user",
						"type": "label",
						"class": "black",
						"p": "0",
						"w": "0",
						"r": "0",
						"x": "1"
					},
					{
						"name": "收款账号",
						"val": "",
						"key": "rec_card",
						"type": "label",
						"class": "black",
						"p": "0",
						"w": "0",
						"r": "0",
						"x": "1"
					},
					{
						"name": "合计金额",
						"val": "",
						"key": "pass_all",
						"type": "label",
						"class": "red",
						"p": "0",
						"w": "0",
						"r": "0",
						"x": "1"
					},
					{
						"name": "待审收入",
						"val": "",
						"key": "in_amount",
						"type": "label",
						"class": "black",
						"p": "0",
						"w": "0",
						"r": "0",
						"x": "2"
					},
					{
						"name": "待审已付",
						"val": "",
						"key": "bef_amount",
						"type": "label",
						"class": "black",
						"p": "0",
						"w": "0",
						"r": "0",
						"x": "2"
					},
					{
						"name": "待审支出",
						"val": "",
						"key": "out_amount",
						"type": "label",
						"class": "black",
						"p": "0",
						"w": "0",
						"r": "0",
						"x": "2"
					},
					{
						"name": "审核收入",
						"val": "",
						"key": "in_ok",
						"type": "label",
						"class": "red",
						"p": "0",
						"w": "0",
						"r": "0",
						"x": "3"
					},
					{
						"name": "审核已付",
						"val": "",
						"key": "bef_ok",
						"type": "label",
						"class": "red",
						"p": "0",
						"w": "0",
						"r": "0",
						"x": "3"
					},
					{
						"name": "审核支出",
						"val": "",
						"key": "out_ok",
						"type": "label",
						"class": "red",
						"p": "0",
						"w": "0",
						"r": "0",
						"x": "3"
					},
					{
						"name": "备注",
						"val": "",
						"key": "note",
						"type": "text",
						"class": "long4",
						"p": "1",
						"w": "0",
						"r": "0",
						"x": "4"
					},
					{
						"name": "补充说明",
						"val": "",
						"key": "sheet_note",
						"type": "textarea",
						"class": "long5",
						"p": "0",
						"w": "0",
						"r": "1",
						"x": "5"
					}
				];

				this.parm_th = [{
						"name": "序号"
					},
					{
						"name": "单号"
					},
					{
						"name": "厂家"
					},
					{
						"name": "起点"
					},
					{
						"name": "终点"
					},
					{
						"name": "货名"
					},
					{
						"name": "申请人",
						"class": "short0"
					},
					{
						"name": "状态",
						"class": "short0"
					},
					{
						"name": "收入费用"
					},
					{
						"name": "确认收入"
					},
					{
						"name": "已付费用"
					},
					{
						"name": "确认已付"
					},
					{
						"name": "支出费用"
					},
					{
						"name": "确认支出"
					},
					{
						"name": "实际收支"
					},
					{
						"name": "明细费用备注",
						"class": "long2"
					},
					{
						"name": "补充说明"
					},
					{
						"name": "收款人"
					},
					{
						"name": "收款人账号"
					},

					{
						"name": "状态说明"
					},
					{
						"name": "修改人",
						"class": "short0"
					},
					{
						"name": "备注说明"
					},
					{
						"name": "附件"
					},
					{
						"name": "申请时间"
					},
					{
						"name": "总运费",
						"class": "short0"
					},
					{
						"name": "已付现金",
						"class": "short0"
					},
					{
						"name": "已付油",
						"class": "short0"
					},
					{
						"name": "未付现金",
						"class": "short0"
					},

					{
						"name": "未付油",
						"class": "short0"
					},
					{
						"name": "存储路径"
					},
					{
						"name": "访问路径"
					},
					{
						"name": "更新时间"
					}
				]

				// console.log('初始核对条件')

				// 明细部分
				this.show_detail = true;
				this.d_sel_action = 'exp_cw_fee_check_d';
				this.d_upd_action = '_cw_fee_check_d';
				this.d_row_id = '';
				this.d_sys_date = '';
				this.d_parm = []; //明细参数构造；
				this.d_name = []; //明细标题

				this.d_parm = [];

				this.d_name = [];

				this.file_action = '';

				this.file_action = '';

				this.p1 = 'item';
				let date = new Date();
				var y = date.getFullYear();
				var m = date.getMonth() + 1;
				m = m < 10 ? ('0' + m) : m;
				var d = date.getDate();
				d = d < 10 ? ('0' + d) : d;
				// var h = date.getHours();
				// h = h < 10 ? ('0' + h) : h;
				// var minute = date.getMinutes();
				// minute = minute < 10 ? ('0' + minute) : minute;
				// this.file_time = y + '' + m + '' + d + '' + h + '' + m;
				this.p2 = y + '' + m + '' + d;
				this.p3 = 'image';

				this.load_db_data();
			},
			loadClass: function(action, p1, p2, p3) {
				let that = this;
				return new Promise((resolve, reject) => {
					// console.log(menuvalue);
					that.$post(
						api.http_method, Method_EasySelect(action, p1, p2, p3)
					).then(res => {
						res = JSON.parse(res);
						// console.log(res.data);
						resolve(res.data)
					});

				});
			},
			select_method: async function(type) {
				// console.log('操作=' + type);

				switch (type) {
					case 'new':
						// this.new_blank();
						this.data_clear();
						break;
					case 'clear':
						this.data_clear();
						break;
					case 'add':
						this.fun_upd('_add');
						break;
					case 'upd':
						this.fun_upd('_upd');
						break;
					case 'del':
						this.fun_upd('_del');
						break;
					case 'sel':
						this.load_db_data();
						break;
					case 'sub':
						// this.fun_upd('_sub');
						let res = await this.fun_sub_check('_sub');

						// console.log(res);
						this.row_id = res.parm.id;
						// 同步关键参数便于后续修改
						this.sheet_no = res.parm.sheet_no;
						this.sys_date = res.parm.sys_date;

						let in_old = 0,
							in_ok = 0,
							out_old = 0,
							out_ok = 0,
							bef_out = 0,
							bef_ok = 0,
							pay_io = 0;
						in_old = Number(res.parm.in_old);
						in_ok = Number(res.parm.in_ok);
						out_old = Number(res.parm.out_old);
						out_ok = Number(res.parm.out_ok);
						bef_out = Number(res.parm.bef_out);
						bef_ok = Number(res.parm.bef_ok);
						pay_io = Number(res.parm.pay_io);

						// console.log('in_old=' + in_old + ' in_ok=' + in_ok);
						// console.log('out_old=' + out_old + ' out_ok=' + out_ok);
						// console.log('bef_out=' + bef_out + ' bef_ok=' + bef_ok);


						let t_msg = '',
							pass_flag = '1';
						if (Number(in_old) == Number(in_ok)) {
							t_msg = '<p>待确认 收入金额:<span class="word-red">' + in_old +
								'</span>与确认金额:<span class="word-red">' + in_ok + '</span>相等</p>';
						} else {
							t_msg = '<p>待确认 收入金额:<span class="word-red">' + in_old +
								'</span>与确认金额:<span class="word-red">' + in_ok + '</span>不相等</p>';
						}


						if (Number(out_old) == Number(out_ok)) {
							t_msg += '<p>待确认 支出金额:<span class="word-red">' + out_old +
								'</span>与确认金额:<span class="word-red">' + out_ok + '</span>相等</p>';
						} else {
							t_msg += '<p>待确认 支出金额:<span class="word-red">' + out_old +
								'</span>与确认金额:<span class="word-red">' + out_ok + '</span>不相等</p>';
						}

						if (Number(bef_out) == Number(bef_ok)) {
							t_msg += '<p>待确认 已付金额:<span class="word-red">' + bef_out +
								'</span>与确认已付:<span class="word-red">' + bef_ok + '</span>相等</p>';
						} else {
							t_msg += '<p>待确认 已付金额:<span class="word-red">' + bef_out +
								'</span>与确认已付:<span class="word-red">' + bef_ok + '</span>不相等</p>';
						}

						if (Number(pay_io) >= 0) {
							t_msg += '<p>实际支出:<span class="word-red">' + pay_io + '</p>'
						} else {
							t_msg += '<p>实际收入:<span class="word-red">' + pay_io * (-1) + '</p>'
						}



						t_msg += '<p>是否提交?</p>'


						// if (Number(in_ok) == 0 && Number(out_ok) == 0) {
						// 	pass_flag = '0'
						// }

						// if (pass_flag == '0') {
						// 	this.$message.error('错误:确认收入与支出金额都是0，不需提交!');
						// 	return;
						// }

						// console.log(t_msg);

						// this.$alert('<strong>这是 <i>HTML</i> 片段</strong>', 'HTML 片段', {
						//   dangerouslyUseHTMLString: true
						// });


						this.$confirm(t_msg, '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning',
							dangerouslyUseHTMLString: true
						}).then(() => {
							this.fun_upd('_sub');
						}).catch(() => {
							this.$message({
								type: 'info',
								message: '已取消提交'
							});
						});
						break;
					case 'bad':
						this.fun_upd('_bad');
						break;
					case 'exl_up':
						this.excelup();
						break;
					case 'exl_down':
						this.build_exceldata();
						break;
					case 'filesel':
						this.fun_sel_file();
						break;
					case 'fileup':
						this.fun_up_file();
						break;
					case 'filelook':
						this.fun_look_file();
						break;
					case 'filedel':
						this.fun_del_fileall();
						break;
					default:
						this.$message.error('错误:标识:' + type + ' 没有配置相应方法!');
						break;
				}
			},
			fun_sub_check: function(type) {

				let that = this;
				return new Promise((resolve, reject) => {

					let d = [];
					d.push(this.sheet_no);
					for (let i = 0; i < that.parm.length; i++) {
						// console.log(this.parm[i].val);
						if (that.parm[i].p == '1')
							d.push(that.parm[i].val);
					}

					let r = (Math.random() + '').substring(0, 8);
					if (that.action_flag == 'long') {
						that.$post(
							api.http_method, Method_CommonLong(that.upd_action + type + 'check',
								that.row_id, that
								.sys_date, d, r)
						).then(res => {
							res = JSON.parse(res);
							resolve(res.data)
						});
					} else {
						that.$post(
							api.http_method, Method_Common(that.upd_action + type + 'check', that
								.row_id, that
								.sys_date, d, r)
						).then(res => {
							res = JSON.parse(res);
							resolve(res.data)
						});
					}

				});

			},
			data_clear: function() {
				// console.log('清除 历史 参数。。。。');

				this.row_id = '';
				this.sys_date = '';
				// 文件名称、路径、储存 选择确定
				this.sheet_flag = '';
				this.sheet_no = '';

				this.file_name = '';
				this.file_url = '';
				this.file_src = '';
				this.file_up = '';

				for (let j = 0; j < this.parm.length; j++) {
					if (this.parm[j].type == 'select') {
						this.parm[j].val = '';
						this.parm[j].sel_name = '';
					} else {
						this.parm[j].val = '';
					}

				}

				for (let j = 0; j < this.parm_sel.length; j++) {
					if (typeof(this.parm_sel[j].type) != 'undefined' && this.parm_sel[j].type == 'select') {
						this.parm_sel[j].val = '';
						this.parm_sel[j].sel_name = '';
					} else {
						this.parm_sel[j].val = '';
					}

				}

				this.kw1 = '';
				this.kw2 = '';
				this.kw3 = '';
				this.kw4 = '';
				this.kw5 = '';
				this.kw6 = '';
				this.kw7 = '';
				this.kw8 = '';
				this.kw9 = '';
				this.kw10 = '';

				this.d_detail = [];

				// console.log('===END============')
			},
			load_db_data: function() {
				// console.log('全条件查询====');
				// console.log(this.parm_sel);
				for (let i = 0; i < this.parm_sel.length; i++) {
					let t = 0;
					t = i + 1 + '';
					switch (t) {
						case '1':
							this.kw1 = this.parm_sel[i].val;
							break;
						case '2':
							this.kw2 = this.parm_sel[i].val;
							break;
						case '3':
							this.kw3 = this.parm_sel[i].val;
							break;
						case '4':
							this.kw4 = this.parm_sel[i].val;
							break;
						case '5':
							this.kw5 = this.parm_sel[i].val;
							break;
						case '6':
							this.kw6 = this.parm_sel[i].val;
							break;
						case '7':
							this.kw7 = this.parm_sel[i].val;
							break;
						case '8':
							this.kw8 = this.parm_sel[i].val;
							break;
						case '9':
							this.kw9 = this.parm_sel[i].val;
							break;
					}
				}

				let that = this;
				let r = (Math.random() + '').substring(0, 8);
				setTimeout(function() {
					that.load_url = api.http_method;
					that.load_json = Select_PageLength(that.sel_action, that.nowpage, that.page_length, that
						.kw1,
						that
						.kw2, that.kw3, that.kw4, that.kw5, that.kw6, that.kw7, that.kw8, that.kw9, '', r);
				}, 200);
			},
			build_exceldata: function(type) {
				// 不做分页
				if (type == 'close') {
					this.show_excel = false;
				} else {

					for (let i = 0; i < this.parm_sel.length; i++) {
						switch (this.parm_sel[i].sel) {
							case '1':
								this.kw1 = this.parm_sel[i].val;

								break;
							case '2':
								this.kw2 = this.parm_sel[i].val;
								break;
							case '3':
								this.kw3 = this.parm_sel[i].val;
								if (this.parm_sel[i].type == 'datemonth') {
									this.kw3 = dateFormatbyChina(this.kw3);
								}
								break;
							case '4':
								this.kw4 = this.parm_sel[i].val;
								if (this.parm_sel[i].type == 'datemonth') {
									this.kw4 = dateFormatbyChina(this.kw4);
								}
								break;
							case '5':
								this.kw5 = this.parm_sel[i].val;
								break;
							case '6':
								this.kw6 = this.parm_sel[i].val;
								break;
							case '7':
								this.kw7 = this.parm_sel[i].val;
								break;
							case '8':
								this.kw8 = this.parm_sel[i].val;
								break;
							case '9':
								this.kw9 = this.parm_sel[i].val;
								break;
							case '10':
								this.kw10 = this.parm_sel[i].val;
								break;
						}
					}


					let postjson = '';
					postjson = Select_PageLength(this.sel_action, this.nowpage, this.page_length, this.kw1, this
						.kw2,
						this.kw3, this.kw4, this.kw5, this.kw6, this.kw7, this.kw8, this.kw9, this.kw10);

					this.postjson1 = Object.assign({}, this.postjson1, {
						type: 'down1',
						url: api.http_method,
						post: postjson
					});

					this.show_excel = true;
				}
			},
			refresh_data: function(type, page, pagelength, backdata) {
				// console.log('查询刷新=' + type + ' page=' + page + ' pagelength=' + pagelength);
				// console.log(backdata);
				// PAGE_LENGTH_CHANGE 改变分页长度,刷新加载
				if (type == 'PAGE_LENGTH_CHANGE') {
					this.nowpage = page;
					this.page_length = pagelength;
					this.load_db_data();
					return;
				}

				let back = null;
				if (type == 'UPDATE_OK' && typeof(backdata) != "undefined" && backdata != '') {
					// 更新编辑信息
					this.nowpage = page;
					this.load_db_data();

					back = JSON.parse(backdata);
					// console.log(back);
					// console.log('new_id=' + back.new_id);
					this.row_id = back.new_id;
					this.sheet_flag = back.msg;
					// 同步关键参数便于后续修改
					this.sys_date = back.sys_date;
					this.sheet_no = back.sheet_no;
					for (let i = 0; i < this.parm.length; i++) {
						if (this.parm[i].key == 'sheet_no') {
							this.parm[i].val = this.sheet_no;
							break;
						}
					}

					// console.log('sheet_flag==' + this.sheet_flag + ' close=' + this.sheet_flag.indexOf('删除成功'))
					if (this.sheet_flag.indexOf('提交成功') >= 0) {
						this.show_btn = false;
					} else {
						this.show_btn = true;
					}

					if (this.sheet_flag.indexOf('删除成功') >= 0) {
						this.closeshow();
						return;
					}



				}

				if (Number(this.row_id) > 0) {
					// 刷新住单据信息
					this.element_loading = true;
					let r = (Math.random() + '').substring(0, 8);
					this.$post(
						api.http_method, Select_PageLength(this.sel_action, 1, 1, 'ID' + this.row_id, '', '', '',
							'', '', '',
							'', '', '', '', '', r)
					).then(res => {
						res = JSON.parse(res);
						// console.log(res);
						this.element_loading = false;
						if (Number.parseInt(res.data.status) == 1) {
							let bd = [];
							let t = res.data.data;
							for (let i = 0; i < t.length; i++) {
								let arr = [];
								for (let j in t[i]) {
									// //console.log('key=' + j);       //输出key
									// //console.log('val=' + t[i][j]); //输出key对应的value
									let o = {};
									o.key = j;
									o.val = t[i][j];
									arr.push(o);
								}
								bd.push(arr);
							}

							this.list_main = t[0];

							this.sel_row(bd[0], 'sel');

						} else {
							this.$message({
								message: '编辑数据更新失败! \r\n ' + res.data.msg,
								type: 'success'
							});
						}

					});
				}
				//如果弹出编辑界面，有非编辑内容。应该查询一下，进行更新


			},
			sel_row: function(item, type) {
				// console.log('选择主单据', item);
				this.list_main = {};
				// console.log('type=' + type);
				// 判断 obj.hasOwnProperty("key")
				//2、遍历Json串获取其属性
				for (let i = 0; i < item.length; i++) {
					switch (item[i].key) {
						case 'id':
							this.row_id = item[i].val;
							break;
						case 'flag':
							this.sheet_flag = item[i].val;
							break;
						case 'sys_date':
							this.sys_date = item[i].val;
							break;
						case 'sheet_no':
							this.sheet_no = item[i].val;
							break;
						case 'f_url':
							let tt = BackSpecial(item[i].val);
							tt = tt.substring(tt.lastIndexOf('/') + 1);
							this.file_name = tt;
							this.file_url = item[i].val;
							if (this.file_name != '') {
								this.file_show = true;
							} else {
								this.file_show = false;
							}
							break;
						case 'f_src':
							this.file_src = item[i].val;
							break;
						default:
							break;
					}
					this.list_main[item[i].key] = item[i].val
				}

				for (let i = 0; i < item.length; i++) {
					for (let j = 0; j < this.parm.length; j++) {
						if (this.parm[j].key == item[i].key) {
							if (this.parm[j].type == 'select' || this.parm[j].type == 'radio') {
								// console.log(this.parm[j]);
								this.parm[j].val = '';
								this.parm[j].sel_name = item[i].val;
							} else {
								this.parm[j].val = item[i].val;
							}

						}
					}
				}

				if (typeof(this.file_name) == 'undefined' || this.file_name == '') {
					this.file_show = false;
				} else {
					this.file_show = true;
				}

				let sheet_type = this.sheet_no.substring(6, 8);
				// console.log('单据状态:' + sheet_type);
				switch (sheet_type) {
					case 'YF':
						this.title = '运输费用申请 核对';
						break;
					case 'SJ':
						this.title = '司机报销申请 核对';
						break;
					case 'PS':
						this.title = '个人报销申请 核对';
						break;
					case 'KL':
						this.title = '看路报销申请';
						break;
					case 'BX':
						this.title = '保险报销申请';
						break;
					case 'JW':
						this.title = '就位报销申请';
						break;
					case 'WB':
						if (this.sheet_no.substring(8, 10) == 'JW') {
							this.title = '外包就位';
						} else if (this.sheet_no.substring(8, 10) == 'XC') {
							this.title = '小车加油';
						} else if (this.sheet_no.substring(8, 10) == 'KL') {
							this.title = '单独看路';
						} else if (this.sheet_no.substring(8, 10) == 'DZ') {
							this.title = '单独吊装';
						} else if (this.sheet_no.substring(8, 10) == 'PH') {
							this.title = '单独配货';
						} else {
							this.title = '未定义';
						}

						break;
					case 'QC':
						if (this.sheet_no.substring(8, 10) == 'CG') {
							this.title = '汽车采购';
						} else {
							this.title = '未定义';
						}

						break;
					default:
						break;
				}


				// console.log('主单', this.list_main);

				// console.log(this.parm);
				switch (type) {
					case 'edit': // 切换背景色
						this.$refs.file_table.setCurrentRowJsonOld('m_', item[1].val);
						break;
					case 'show': // 打开编辑页面
						this.$refs.mypop.showpop();


						break;
					case 'del': // 执行删除
						this.fun_upd('_del');
						break;
					default:
						break;
				}

				if (type == 'sel' || type == 'show') {
					if (this.show_detail) {
						this.fun_d_load();
					}
				}



			},
			fun_d_load: function() {


				this.element_loading = true;

				this.out_ok = 0;
				this.out_amount = 0;

				this.$post(
					api.http_method,
					Sel_page_and_length(this.d_sel_action, 1, 999, this.sheet_no)
				).then(res => {
					this.element_loading = false;

					res = JSON.parse(res);

					this.list_detail = [];
					if (res.length > 0) {
						let t = res[0];
						// console.log('明细返回', t);

						let t_out_ok = 0;
						let t_out = 0;
						let t_zh = 0;
						for (let i = 0; i < t.length; i++) {
							t[i].row_num = i + 1;

							t_out = t_out + Number(t[i].apply_amount);
							t_out_ok = t_out_ok + Number(t[i].ok_amount);
							if (t[i].is_pay == '1' || t[i].is_pay == '') {
								t_zh = t_zh + Number(t[i].ok_amount);
							}

							this.list_detail.push(t[i]);
						}

						this.out_ok = t_out_ok;
						this.out_amount = t_out;
						// console.log(this.list_detail);
					} else {
						this.$message({
							message: "没有查询到明细",
							type: 'success'
						});
					}
				});

			},
			new_blank: async function() {
				this.show_tan = true;
				this.show_btn = true;
				this.show_btn_ok = false;

				await this.data_clear();


				this.$refs.mypop.showpop();

			},
			closeshow: function() {
				this.$refs.mypop.closeshow();
			},
			fun_del: function(d) {
				this.sel_row(d, 'del');
			},
			fun_upd: async function(type) {
				// console.log('操作类型=' + type + ' row_id=' + this.row_id);
				if (type == '_upd' || type == '_del') {
					if (this.row_id == 0) {
						this.$message({
							message: '请选择要修改的数据!',
							type: 'warning'
						});
						return;
					}
				}

				// 删除附件
				// if (type == '_del') {
				//   this.fun_del_fileall();
				// }

				if (type == '_add') {
					let stop = false;
					let temp_name = '';
					for (let i = 0; i < this.parm.length; i++) {
						// console.log(this.parm[i]);
						if (this.parm[i].p == '1' && this.parm[i].w == '1' && this.parm[i].val == '') {
							stop = true;
							temp_name = this.parm[i].name;
							break;
						}
					}
					if (stop) {
						this.$message({
							message: temp_name + '不能为空!',
							type: 'warning'
						});
						return;
					}
				}

				for (let i = 0; i < this.parm.length; i++) {
					// console.log(this.parm[i].val);
					if (this.parm[i].p == '1') {
						let temp = '';
						if (this.parm[i].type == 'time' || this.parm[i].type == 'datetime') {
							temp = dateFormatbyChina(this.parm[i].val);
						} else if (this.parm[i].type == 'selectnew') {
							console.log(this.parm[i].key + '下拉选项', this.parm[i])
							if (typeof(this.parm[i].val) === 'number' && Number(this.parm[i].val) > 0) {
								temp = this.parm[i].val;
							} else {
								temp = '0';
								for (let j = 0; j < this.parm[i].list.length; j++) {
									if (this.parm[i].list[j].val == this.parm[i].sel_name) {
										temp = this.parm[i].list[j].id;
									}
								}
							}

						} else if (this.parm[i].type == 'select') {
							console.log(this.parm[i].key + '下拉选项', this.parm[i])
							if (typeof(this.parm[i].val) === 'number' && Number(this.parm[i].val) > 0) {
								temp = this.parm[i].val;
							} else if (typeof(this.parm[i].list) !== 'undefined' && this.parm[i].list.length > 0) {
								let tlist = [];
								tlist = this.parm[i].list;
								for (let j = 0; j < tlist.length; j++) {
									if (tlist[j].val == this.parm[i].sel_name) {
										temp = tlist[j].id;
									}
								}
							} else {
								temp = '0';
								let t_action = this.parm[i].sel_action;
								let res = await this.loadClass(t_action);
								console.log(res);
								if (res.status == '1') {
									let tlist = res.data;
									for (let j = 0; j < tlist.length; j++) {
										if (tlist[j].val == this.parm[i].sel_name) {
											temp = tlist[j].id;
										}
									}
								}

							}

						} else {
							temp = this.parm[i].val;
						}

						this.parm[i].val = temp;
					}
				}

				let d = [];

				for (let i = 0; i < this.parm.length; i++) {
					if (this.parm[i].p == '1') {
						d.push(this.parm[i].val);
					}
				}

				let r = (Math.random() + '').substring(0, 8);

				this.upd_json = Method_Common(this.upd_action + type, this.row_id, this.sys_date, d, r);


			},
			load_upAllFile: function(p1, p2) {
				let that = this;
				return new Promise((resolve, reject) => {
					// console.log(menuvalue);
					// exp_getfilesrc_item_base 查询所有文件路径
					that.$post(
						api.http_method, Select_PageLength('exp_getfilesrc_item_base', 1, 100, p1, p2)
					).then(res => {

						res = JSON.parse(res);
						// console.log(res);
						resolve(res[0])
					});

				});
			},
			show_detaildata: function(that, item, type) {
				var x = 0,
					y = 0,
					temp_css = '';
				// console.log('明细数据显示坐标 ' + x + ' ' + y);
				// console.log(that);
				x = that.pageX + 10;
				y = that.pageY;

				var screenWidth = $(window).width();
				var screenHeight = $(window).height(); //当前浏览器窗口的 宽高
				// var scrolltop = $(document).scrollTop();//获取当前窗口距离页面顶部高度

				// console.log('页面宽度=' + screenWidth + '页面高度=' + screenHeight);
				// console.log('明细数据显示坐标 ' + x + ' ' + y);

				if ((x + 140) > screenWidth) {
					x = x - 160;
				}

				temp_css = "display: block;position: absolute;top:" + y + "px;left:" + x +
					"px;background-color: #99CCFF;border: 1px solid black;padding-left: 20px;padding-right: 20px;border-radius: 5px;z-index: 99999;";
				if (type == "0" && item.detail_data.length > 0) {
					this.detail_data = item.detail_data;
					// console.log($('#pre_detail_data'));
					document.getElementById("pre_detail_data").style.cssText = temp_css;
				}
				if (type == "1" && item != '') {
					temp_css += "max-width: 500px;word-break: break-all;padding-top: 5px;padding-bottom: 5px;";

					let temp_innerHtml = '';
					temp_innerHtml = BackSpecial(item);
					console.log(temp_innerHtml)
					// 只替换了一个
					// temp_innerHtml = temp_innerHtml.replace(new RegExp('^', 'g'), "<br>");
					// temp_innerHtml = temp_innerHtml.replace(/\r\n/g,"<br>");
					// temp_innerHtml = temp_innerHtml.replace(/\n/g,"<br>");
					let arr = temp_innerHtml.split('\r\n');
					console.log(arr)
					let new_str = '';
					for (let i = 0; i < arr.length; i++) {
						console.log('替换。。。')
						new_str = new_str + arr[i] + "<br/>";
					}

					document.getElementById("pre_msg_data").innerHTML = new_str;
					document.getElementById("pre_msg_data").style.cssText = temp_css;
				}
			},
			noshow_detaildata: function() {
				// console.log('不显示明细');
				document.getElementById("pre_detail_data").style.display = 'none';
				document.getElementById("pre_msg_data").style.display = 'none';
			},
			check_d_parm: function() {
				// console.log('sheet_no=' + this.sheet_no);
				for (let i = 0; i < this.parm.length; i++) {
					if (this.parm[i].key == 'sheet_no') {
						this.sheet_no = this.parm[i].val;
						break;
					}
				}
				// console.log('sheet_no=' + this.sheet_no);
				let nosheet_no = true;
				for (let i = 0; i < this.d_parm.length; i++) {
					if (this.d_parm[i].key == 'sheet_no') {
						this.d_parm[i].val = this.sheet_no;
						nosheet_no = false;
						break;
					}
				}
				//	针对 没有单号 的明细 补充,默认 m_id 为主单ID add 2021-03-26
				if (nosheet_no) {
					for (let i = 0; i < this.d_parm.length; i++) {
						if (this.d_parm[i].key == 'm_id') {
							this.d_parm[i].val = this.row_id;
							break;
						}
					}
				}

				let that = this;
				return new Promise((resolve, reject) => {
					let flag = false;
					for (let i = 0; i < that.d_parm.length; i++) {
						if (that.d_parm[i].weight == '1' && that.d_parm[i].val == '') {
							that.$message({
								message: that.title + '明细: ' + that.d_parm[i].name + '为必填项,不能为空!',
								type: 'warning'
							});
							flag = true;
							break;
						}
					}
					resolve(flag)
				})
			},
			d_data_clear: function() {
				this.d_row_id = '';
				this.d_sys_date = ''

			},
			fun_d_upd: function(type, item) {

				// console.log('编辑', item);
				// console.log(item);
				this.d_data_clear();

				this.d_row_id = item.id;
				this.d_sys_date = item.sys_date;


				this.ok_amount = item.ok_amount;
				this.ok_note = item.ok_note;


				if (type == '_upd') {
					this.fun_d_save('_upd');
				}

				// this.setActiveRowBackColor('d', item[0].val, 'detail');
			},
			fun_d_del: function(type, item) {
				let flag = true;

				this.d_row_id = item.id;


				if (flag) {
					this.$confirm('此操作将删除该数据, 是否继续?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.fun_d_save(type);
					}).catch(() => {
						this.$message({
							type: 'info',
							message: '已取消删除'
						});
					});

				} else {
					this.$message({
						message: '请先删除附件,再删除数据!',
						type: 'warning'
					});
				}
			},
			fun_d_save: async function(type) {
				if (type == '_del') {
					if (this.d_row_id == 0) {
						this.$message({
							message: '请选择要删除的数据!',
							type: 'warning'
						});
						return;
					}
				}

				if (type == '_add') {
					let flag = false;
					flag = await this.check_d_parm();
					if (flag) {
						return;
					}
				}

				if (type == '_upd') {
					if (this.d_row_id == 0) {
						this.$message({
							message: '请选择要修改的数据!',
							type: 'warning'
						});
						return;
					}
				}

				if (Number(this.ok_amount) < 0) {
					this.$message({
						message: '确认金额最小=0,不能是负数!',
						type: 'warning'
					});
					return;
				}



				let d = [];
				d.push(this.sheet_no);
				d.push(this.ok_amount);
				d.push(this.ok_note);

				// console.log('d_row_id=' + this.d_row_id);
				let temp_data = '';
				temp_data = Method_Common(this.d_upd_action + type, this.d_row_id, this.d_sys_date, d);

				this.element_loading = true;
				this.$post(
					api.http_method, temp_data
				).then(res => {
					try {
						res = JSON.parse(res);

						if (res.data.status == 1) {
							this.$message({
								message: res.data.msg,
								type: 'success'
							});
							// console.log(res.data.parm);
							// this.d_row_id = res.data.parm.id;
							// this.d_sys_date = res.data.parm.sys_date;

							// document.getElementById('isfirst').focus();
							let that = this;
							setTimeout(function() {
								that.refresh_data();
							}, 100)

						} else {
							for (let i = 0; i < this.list_detail.length; i++) {
								if (this.list_detail[i].id == this.d_row_id) {
									this.list_detail[i].ok_amount = '';
									break;
								}
							}
							this.$message.error(res.data.msg);
						}
						this.element_loading = false;

					} catch (ex) {
						this.element_loading = false;
						this.$message({
							message: "查询失败" + ex,
							type: 'warning'
						});
					}
				})

			},

			//附件操作 start //////////////////////////////////////
			// 点击上传附件
			fun_sel_file: function() {
				// console.log('点击选择附件=' + this.row_id);
				if (this.row_id == null || Number(this.row_id) == 0) {
					this.$message({
						message: '操作不正确1,请选择要上传附件的具体分类信息!',
						type: 'warning'
					});
					return;
				}
				console.log(this.file_url);
				if (this.file_url != '') {
					this.$message({
						dangerouslyUseHTMLString: true,
						message: '操作不正确2,已经上传附件<div class="mtop mdown" > 名称=' + this.file_name + '</div>请检查!'
					});
					return;
				}

				this.file_name = '';
				this.file_data = '';
				this.file_up = '';
				this.file_size = 0;
				this.file_type = '';

				this.file_url = '';
				this.file_src = '';

				let fileobj = document.getElementById('savefile');
				fileobj.click();
			},
			fun_look_file: async function(item) {
				console.log('点击预览附件');
				if (typeof(item) !== 'undefined' && item != '') {
					await this.sel_row(item);
				}

				if (this.file_url == null || String(this.file_url).length == 0 || String(this.file_url) == '') {
					this.$message({
						dangerouslyUseHTMLString: true,
						message: '操作不正确,已经上传附件<div class="mtop mdown" > 名称=' + this.file_name + '</div>请检查!'
					});
					return;
				}

				if (/\.(gif|jpg|jpeg|png|ico|pdf)$/.test(this.file_name.toLowerCase())) {
					// 会被火狐浏览器弹窗阻止,360和谷歌正常
					var pdfview = document.getElementById('loodlink');
					pdfview.href = this.file_url;
					// window.open(tv_url, '_blank'); //被弹窗阻止
					pdfview.click();

				} else {
					this.$message({
						message: '该类型文件暂不支持预览,将开始下载!',
						type: 'success'
					});

					let down_file = document.getElementById("downlink");
					let temp_url = BackSpecial(this.file_url);
					let temp_filename = BackSpecial(BackSpecial(temp_url.substring(temp_url.lastIndexOf('/') + 1)));
					down_file.download = this.file_name; // 下载名称
					down_file.href = temp_url; // 绑定a标签
					down_file.click(); // 模拟点击实现下载
				}
			},
			getFilePath: function() {
				let tmpFile = document.getElementById('savefile');
				// console.log('点击选择结果');
				console.log(tmpFile.files);
				if (typeof FileReader !== "undefined") {
					let max_size = 5000; // 50k 20M
					let name = '';
					let size = 0;
					let fileData = tmpFile.files[0];

					this.file_backdata = fileData;
					name = fileData.name;
					size = fileData.size;
					this.file_size = size;

					// console.log('名称=' + name + ' 大小=' + size);
					if (!(/\.(gif|jpg|jpeg|png|ico|pdf)$/.test(name.toLowerCase()))) {
						this.$message({
							message: '只可以上传图片、pdf、doc、docx、zip、rar格式',
							type: 'warning'
						});
						return;
					}
					this.file_name = name;

					if (size > max_size * 1024) {
						this.$message({
							message: '图片大小不能超过5M',
							type: 'warning'
						});
						return
					}
					// console.log(tmpFile);   //连标签原样输出了
					// console.log(tmpFile.value);   //图片路径

					let reader = new FileReader(); // FileReader
					let that = this;
					reader.readAsDataURL(fileData);
					reader.onload = function() {
						// 获取到base64图片内容
						that.file_data = this.result;
					}
					this.file_show = true;

				} else {
					this.$message({
						message: '当前浏览器不支持上传组件',
						type: 'warning'
					});
				}

			},
			fun_del_fileall: async function() {
				this.list_upfileall = [];
				this.list_upfileall = await this.load_upAllFile(this.row_id);
				console.log(this.list_upfileall)
				if (typeof(this.list_upfileall) !== 'undefined') {
					for (let i = 0; i < this.list_upfileall.length; i++) {
						if (this.list_upfileall[i].f_src != '') {
							await this.fun_del_file(this.list_upfileall[i]);
						}
					}
					this.load_db_data();
				}
			},
			fun_del_file: function(item) {
				console.log(item);
				var postdata = "";
				postdata =
					'{"action":"' + 'file_del_upfile' + this.file_action + '","user_no":"' +
					item.sign_no +
					'","upfile_path":"' +
					base_encode(item.file_src) +
					'","sheet_no":"' +
					'' +
					'","rowid":"' +
					item.id +
					'","sys_date":"' +
					item.sys_date +
					'"}';

				postdata =
					'{"method":"File_load","data":"' + base_encode(postdata) + '"}';

				let that = this;
				return new Promise((resolve, reject) => {
					// console.log(menuvalue);
					that.$post(
						api.http_method, postdata
					).then(res => {
						// console.log(res);
						res = JSON.parse(res);
						resolve(res.data)
					});

				});



			},
			fun_up_file: async function() {
				// 一块文件的大小
				this.blockSize = 1 * 1024 * 1024;
				// console.log('文件大小=' + this.file_data.length)
				if (this.file_data.length > 0) {
					let random_name = GetRandom();
					this.file_name = random_name + this.file_name;

					await this.fun_up_file_max();
					// this.element_loading = false;
				} else {
					this.$message({
						message: '未发现上传文件!',
						type: 'warning'
					});
				}
			},
			fun_up_file_max: async function() {
				// 大于1M，分段上传
				let num = 1;
				let start = 0;
				let end = 0;
				let maxFileLength = 0;
				maxFileLength = this.file_backdata.size;
				console.log('原始文件总长度=' + maxFileLength + ' 标准块=' + this.blockSize);

				while (start < maxFileLength) {
					end = start + this.blockSize;
					if (end > maxFileLength) {
						end = maxFileLength;
					}


					let temp_data = '';
					temp_data = this.file_backdata.slice(start, end); //文件切片
					// console.log('上传长度=' + temp_data.size);
					// console.log(temp_data);
					// 上传出错则重新上传
					let res = '';
					try {
						res = await this.fun_up_file_block(temp_data);
						console.log(res);
						if (res.status == 1) {
							this.file_up = '数据块' + (num + 1) + '完成 总进度:' + ((end / maxFileLength) * 100).toFixed(2) +
								" %";
						} else {

						}
					} catch (error) {
						res = await this.fun_up_file_block(temp_data);
					}
					start = end;
					num++;
				}

				this.fun_up_file_savepath();
			},
			fun_up_file_block: async function(temp_data) {
				// console.log('点击上传附件');
				if (this.p3 == '') {
					this.p3 = GetShort("userno");
				}
				// console.log('p3=' + this.p3);
				let that = this;
				var postdata = "";

				let temp_filedata = await this.fun_blod_toString(temp_data);

				postdata =
					'{"user_no":"' +
					GetShort("userno") +
					'","upfile_name":"' +
					DeleteSpecialWord(this.file_name) +
					// '","upfile_type":"' +
					// this.file_type +
					// '","upfile_size":"' +
					// this.file_size +
					'","upfile_data":"' +
					temp_filedata +
					'","rowid":"' +
					this.row_id +
					'","sheet_no":"' +
					this.sheet_no +
					'","p1":"' +
					this.p1 +
					'","p2":"' +
					this.p2 +
					'","p3":"' +
					this.p3 +
					'"}';
				postdata =
					'{"method":"File_block","data":"' + base_encode(postdata) + '"}';

				return new Promise((resolve, reject) => {
					// console.log(menuvalue);
					that.$post(
						api.http_method, postdata
					).then(res => {
						res = JSON.parse(res);
						// console.log(res);

						resolve(res.data)
					})
				});

			},
			fun_blod_toString: function(fileData) {
				return new Promise((resolve, reject) => {

					let reader = new FileReader(); // FileReader
					reader.readAsDataURL(fileData);
					reader.onload = function() {
						// 获取到base64图片内容
						// console.log(this.result);
						// let f='';
						// f=ChangeSpecial(this.result);
						// console.log(f);
						resolve(this.result);
					}

				});
			},
			fun_up_file_savepath: function() {
				if (this.p3 == '') {
					this.p3 = GetShort("userno");
				}
				console.log('p3=' + this.p3);
				this.element_loading = true;

				var postdata = "";
				postdata =
					'{"action":"data_save' + this.file_action + '","user_no":"' +
					GetShort("userno") +
					'","f_name":"' +
					DeleteSpecialWord(this.file_name) +
					'","f_type":"' +
					this.file_type +
					'","f_size":"' +
					this.file_size +
					'","f_path":"' +
					this.p1 + '/' + this.p2 + '/' + this.p3 + '/' + this.file_name +
					'","rowid":"' +
					this.row_id +
					'","sheet_no":"' +
					this.sheet_no +
					'","mode_type":"' +
					this.mode_type +
					'","mode_name":"' +
					this.mode_name +
					'"}';

				// console.log(postdata);
				postdata =
					'{"method":"File_NewSavePath","data":"' + base_encode(postdata) + '"}';


				let that = this;
				this.$post(
					api.http_method,
					postdata
				).then(res => {
					res = JSON.parse(res);
					res = res.data;
					this.element_loading = false;
					if (res.status == 1) {
						that.file_up = "上传成功";

						that.file_url = BackSpecial(res.f_url);
						that.file_src = BackSpecial(res.f_src);

						that.load_db_data();

						this.$message({
							message: '上传成功',
							type: 'success'
						});
					} else {
						this.file_up = "上传失败";

						this.$message({
							message: '上传失败\n\r' + res.msg,
							type: 'success'
						});
					}

				});

			},

		}
	};
</script>


<style scoped>
	/* 设置 倒数 第二、第三列 隐藏 */
	.last-two-none>td:nth-last-child(3),
	.last-two-none>td:nth-last-child(4) {
		display: none;
	}

	.last-two-none>td:nth-last-child(3) {
		display: none;
	}

	.last-two-none>th:nth-last-child(3),
	.last-two-none>th:nth-last-child(4) {
		display: none;
	}

	.last-two-none>th:nth-last-child(3) {
		display: none;
	}

	.tab-main {
		display: inline-flex;
		background-color: #ebebebd9;
		justify-items: center;
		align-items: center;
		align-content: space-around;
		justify-content: space-around;
		padding: 10px;
		border-radius: 5px;
		flex-direction: column;
	}

	.tab-row {
		display: inline-flex;
		width: 100%;
		margin-bottom: 2px;
	}

	.tab-row .item {
		display: inline-flex;
		margin: 2px;
	}

	.tab-row .item label {
		display: inline-flex;
		min-width: 80px;
		text-align: right;
		justify-content: flex-end;
		align-items: center;
	}

	.tab-row .item span {
		display: inline-flex;
		font-size: 16px;
		font-weight: bold;
		min-width: 68px;
		align-items: center;
	}

	.tab-menu {
		display: inline-flex;
		align-items: center;
		width: 100%;
		flex-direction: row;
		flex-wrap: wrap;
		justify-content: space-between;
		/* margin-top: 20px; */
	}

	.tab-menu .left,
	.tab-menu .right {
		display: inline-flex;
		align-items: center;
	}

	.tab-menu .right button {
		font-size: 20px;
	}

	.tab-detail {

		display: inline-flex;
		width: 100%;
		margin-top: 6px;
	}

	.tab-txtlong {
		display: inline-block;
		min-width: 600px;
		width: 100%;
		overflow: auto;
		min-height: 120px;
		font-size: 18px;
		line-height: 24px;
		border: 0px;
		font-weight: 500;
		font-family: cursive;
	}
</style>